import React from 'react';
import _ from 'lodash';

const QUIZ_MAXWIDTH = 440;
const QUIZ_BASE_SRC = 'https://quiz.millionmind.com/js/quizplayer/embed.js?size=small&width=440&height=310&';

export default class QuizRenderer extends React.Component {

  componentDidMount() {
    this.buildQuizScript();
  }

  buildQuizScript() {
    const { data } = this.props;
    const customSrcParameters = _.map(_.pickBy(data), (value, key) => {
      return `${key}=${value}`;
    }).join('&');

    const quizScript = document.createElement('script');
    quizScript.id = _.get(data, 'script');
    quizScript.type = 'text/javascript';
    quizScript.src = QUIZ_BASE_SRC + customSrcParameters;
    quizScript.charset = 'utf-8';
    this.refs.quizContainer.appendChild(quizScript);
  }

  render() {
    return (
      <div ref="quizContainer" style={{ maxWidth: QUIZ_MAXWIDTH, margin: '0 auto' }} />
    );
  }
}

QuizRenderer.propTypes = {
  data: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/component/QuizRenderer.jsx